import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';

import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';
import { BookingType } from '@fry/booking/lib';
import { LanguageService } from '@fry/lib/organisations/language.service';

@Component({
    selector: 'eas-booking-type-slot',
    templateUrl: './booking-type-slot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingTypeSlotComponent implements OnInit {
  @Input() bookingType: BookingType;

  public buttons: EASLinkAction[];

  constructor(
    private security: SecurityService,
    private language: LanguageService,
  ) { }

  ngOnInit() {
    const originalLanguageCode = this.language.getOriginalLanguageCode();
    const translationLanguageCodes = this.language.getTranslationLanguageCodes();

    const translateButtons: EASLinkAction[] = translationLanguageCodes.map(translationLanguageCode => ({
      type: 'link',
      label: $localize `Edit translation (${translationLanguageCode})`,
      condition: () => {
        return this.security.hasPermission('translations.view');
      },
      link: of(['/', 'translation', this.bookingType.doc.type, this.bookingType.doc._id, translationLanguageCode])
    }));

    this.buttons = [
      {
        type: 'link',
        label: $localize `Create new booking item`,
        condition: () => this.security.hasPermission('bookingItems.create'),
        link: of(['..', 'booking-items', 'add']),
        queryParams: { type: this.bookingType.doc._id },
      },
      {
        type: 'link',
        label: translationLanguageCodes.length === 0 ? $localize `Edit` : $localize `Edit original (${originalLanguageCode})` ,
        condition: () => {
          return of(true);
        },
        link: of([this.bookingType.doc._id, 'edit'])
      },
      ...translateButtons
    ];
  }
}
